import { api, API } from "@/lib/api";

// ---- Admin defaults ----
export const adminGetStudyPackDefaults = () =>
  api.get(`/admin/payment-settings/study-pack-defaults`).then((r) => r.data);

export const adminPutStudyPackDefaults = (patch) =>
  api
    .put(`/admin/payment-settings/study-pack-defaults`, patch)
    .then((r) => r.data);

// ---- Teacher: per-course pricing ----
export const putCourseStudyPackSettings = (courseId, patch) =>
  api
    .put(`/courses/${courseId}/study-pack-settings`, patch)
    .then((r) => r.data);

// ---- Student ----
export const studentStudyPackPreview = (enrollmentId) =>
  api
    .get(`/student/enrollments/${enrollmentId}/study-pack/preview`)
    .then((r) => r.data);

export const studentStudyPackCheckout = (enrollmentId, body) =>
  api
    .post(`/student/enrollments/${enrollmentId}/study-pack/checkout`, body)
    .then((r) => r.data);

// ---- PDF ----
export const studyPackPdfUrl = (courseId) =>
  `${API}/courses/${courseId}/study-pack.pdf`;

/**
 * Open the Study Pack PDF in a new tab using a bearer token.
 */
export async function openStudyPackPdf(courseId, fallbackName = "study_pack.pdf") {
  const token = localStorage.getItem("kks_access_token");
  const resp = await fetch(studyPackPdfUrl(courseId), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(txt || `HTTP ${resp.status}`);
  }
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) {
    const a = document.createElement("a");
    a.href = url;
    a.download = fallbackName;
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
